// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vtlk7","colMin":"styles_colMin__2Yd5b"};